import React, { useState } from 'react';
import { X, AlertCircle, Save } from 'lucide-react';
import axios from '../routers/axios';

const QuizCreationModal = ({ isOpen, onClose, onCreated }) => {
  const [formData, setFormData] = useState({
    test_name: '',
    test_code: '',
    description: '',
    instruction: '{}',   // JSON, có thể để rỗng
    created_by: 1,       // giả sử đang là user id 1 (sau này lấy từ auth)
    is_active: true,
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.test_name.trim()) {
      newErrors.test_name = 'Tên bài kiểm tra là bắt buộc';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const payload = {
        test_name: formData.test_name,
        test_code: formData.test_code || null,
        description: formData.description || null,
        instruction: formData.instruction || '{}',
        created_by: formData.created_by,
        is_active: formData.is_active ? 1 : 0,
      };

      try {
        const res = await axios.post("http://127.0.0.1:8000/test/create", payload, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("✅ Tạo test thành công:", res.data);
        if (onCreated) onCreated(res.data);
        onClose();
      } catch (err) {
        if (err.response) {
          console.error("❌ Lỗi server:", err.response.status, err.response.data);
        } else if (err.request) {
          console.error("❌ Không nhận được phản hồi từ server:", err.request);
        } else {
          console.error("❌ Lỗi khi tạo test:", err.message);
        }
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={onClose}></div>

        <div className="inline-block w-full max-w-2xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-xl">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">
              Tạo bài kiểm tra mới
            </h3>
            <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600">
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="px-6 py-6 space-y-6">
            {/* Test name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tên bài kiểm tra <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={formData.test_name}
                onChange={(e) => handleInputChange('test_name', e.target.value)}
                placeholder="Ví dụ: Kiểm tra giữa kỳ, Test 3..."
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.test_name ? 'border-red-500' : 'border-gray-300'
                  }`}
              />
              {errors.test_name && (
                <div className="mt-1 flex items-center text-red-500 text-sm">
                  <AlertCircle className="w-4 h-4 mr-1" />
                  {errors.test_name}
                </div>
              )}
            </div>

            {/* Test code */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mã bài kiểm tra
              </label>
              <input
                type="text"
                value={formData.test_code}
                onChange={(e) => handleInputChange('test_code', e.target.value)}
                placeholder="VD: TEST001"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mô tả
              </label>
              <textarea
                rows={3}
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                placeholder="Nhập mô tả ngắn gọn..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            {/* Active toggle */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="is_active"
                checked={formData.is_active}
                onChange={(e) => handleInputChange('is_active', e.target.checked)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded"
              />
              <label htmlFor="is_active" className="ml-2 text-sm text-gray-700">
                Kích hoạt bài kiểm tra
              </label>
            </div>

            {/* Footer */}
            <div className="flex flex-col sm:flex-row sm:justify-end gap-3 pt-6 border-t border-gray-200 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                type="submit"
                className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
              >
                <Save className="w-4 h-4 mr-2" />
                Tạo bài kiểm tra
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export { QuizCreationModal };
